
import SelectorEngine from '../../utils/dom/selector-engine';

class BecomeMember {
	constructor() {
		this.wrapper = SelectorEngine.findOne('.p-become-a-member');
		if(!this.wrapper) {
			// Not a Become A Member Page.
			return;
		}
		this.init();
	}

	init() {
		this.storeReferral();
	}

	storeReferral() {
		const parameters = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParameters, property) => searchParameters.get(property),
		});
		const referralCode = parameters.code;
		const advantageMemberCode = parameters.advantageMemberCode;
		if(referralCode){
			localStorage.setItem('referralCode', referralCode);
		}
		if(advantageMemberCode){
			localStorage.setItem('advantageMemberCode', advantageMemberCode);
		}
	}
}

const globalBecomeMember = new BecomeMember();
export default globalBecomeMember;
